import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const SOIN_IMAGE = "https://static.prod-images.emergentagent.com/jobs/a6c78920-575a-493b-96c8-ce4b29503ec2/images/616b9515827fb2221a8c43529c53ef054d3b6b0e234d6156e4a0042e96097cfc.jpeg";

export const soinActif = (e) => !e.annule && new Date(e.date_fin || e.date) >= new Date();

export const useSoins = () => {
  const [soins, setSoins] = useState(null);
  useEffect(() => {
    api.events({ type: "soin" }).then((l) => setSoins(l.filter(soinActif).sort((a, b) => new Date(a.date) - new Date(b.date)))).catch(() => setSoins([]));
  }, []);
  return soins;
};

export const soinDateLabel = (e) => e.date_label || new Intl.DateTimeFormat("fr-CH", { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(new Date(e.date));
export const soinOuvert = (e) => e.prix != null && e.prix > 0 && (e.places_illimitees || e.places_restantes > 0);
